import { Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"

import AuthActions from "../../Containers/LoginPage/reducer"

import "./styles.less"

const { Text } = Typography

const LogOutText = ({ disable }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  return (
    <Text type="secondary" className="logout-wrapper">
      {t("Already have an account?")}
      <span
        className={disable ? "disabled" : ""}
        onClick={() => !disable && dispatch(AuthActions.logout())}
      >
        {t("Sign in")}
      </span>
    </Text>
  )
}

export default LogOutText
